<template>
    <div>
        <!-- 弹出窗口,此窗口替代其他dialog类型的组件,新功能使用此组件开发 -->
        <el-dialog :close-on-click-modal="clickClose" :close-on-press-escape="clickEscClose" :model-value="dialogWin.state" :destroy-on-close="true" draggable @close="close"
                   :width="width?width:700" :top="top" :align-center="center" :zIndex="zIndex">
            <template #header>
                <div class="title">
                    {{dialogWin.title}}
                </div>
            </template>
            <el-scrollbar>
                <template v-if="dialogWin.type == 'form'" >
                    <formData ref="formData" :form="formData.form" :data="formData.data" :rules="formData.rules" :k="0" :autoHeight="true"></formData>
                </template>
                <template v-if="dialogWin.type == 'table'">
                    <tables ref="tables" :tableData="tableData" tableKey="dialogWin"></tables>
                </template>

            </el-scrollbar>
            <template #footer >
                <el-button @click="close">关 闭</el-button>
                <el-button @click="save" v-if="dialogWin.saveBtn==false?false:true" color="#ff6633"
                           type="primary" style="color: #ffffff;">{{dialogWin.saveBtnText?dialogWin.saveBtnText:'保 存'}}</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import tables from '@/components/tables.vue'
    import formData from '@/components/formData.vue'

    export default {
        name: "dialogWin", //弹出窗口组件
        components:{
            tables,
            formData,
        },
        props: {
            //点击其他地方是否可以关闭页面
            clickClose:{
                type: Boolean,
                default: false
            },
          //点击其他地方是否可以关闭页面
          clickEscClose:{
            type: Boolean,
            default: true
          },
            //窗口宽度
            width:{
                type: null,
                default: null
            },
            //窗口距顶部距离
            top:{
                type: null,
                default: null
            },
            zIndex:{
              type: null,
              default: 3000
            },
            //窗口是否上下左右居中
            center:{
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                //窗口信息
                dialogWin:{
                    state: false,   //窗口显示
                    title: "",      //窗口标题
                    type:'',        //窗口类型 eg: form, table
                },
                //table类型的数据
                tableData:{},
                //form类型的数据
                formData:{},
            }
        },
        methods:{

            /**
             * 获取表格对象
             */
            getTable(){
                return this.$refs.tables
            },

            /**
             * 获取表单对象
             */
            getFormData(){
                return this.$refs.formData
            },

            /**
             * 保存点击
             */
            save(){
                //表单回调提交
                if(this.dialogWin.type == 'form'){
                    this.$refs.formData.submit().then(res =>{
                        return this.formData.onSubmit();
                    });
                }

            },

            /**
             * 关闭回调
             */
            close(){
                this.dialogWin.state = false;
                if(this.dialogWin && this.dialogWin.onClose){
                    return this.dialogWin.onClose();
                }
            },

            /**
             * 初始化数据
             */
            init(e, extraData){
                this.dialogWin = e;
                if(this.dialogWin.type == 'table'){
                    this.tableData = extraData
                }
                else if(this.dialogWin.type == 'form'){
                    this.formData = extraData
                }
            },
        }
    }
</script>

<style scoped>
    .title{
        font-weight: 800;
        font-size: 17px;
    }
    :deep(.el-dialog__header){
        border-bottom: 1px solid #f2f2f2;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    :deep(.el-dialog__close) {
        font-size: 24px!important;
    }
    :deep(.el-dialog) {
        border-radius: 8px;
    }
    :deep(.el-dialog__body){
        padding-top: 8px;
        padding-bottom: 8px;
    }
</style>
